export const getEvalYears = state => state.result.evalYears;
